var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
  'slo-tooltip': true,
  'slo-tooltip--inset': _vm.inset,
  [`slo-tooltip--inset-${_vm.insetDirection}`]: _vm.inset
}},[_vm._t("default"),_vm._v(" "),(_vm.enabled)?_c('div',{class:{
      'slo-tooltip--text': true,
      [`slo-tooltip--position--${_vm.position}`]: true
    },domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }